<div class="read-only-field-wrapper">
  <span class="read-only-label">
    {{ labelText }}
  </span>
  <span class="field">
    {{ fieldText }}
  </span>
</div>
